export enum NoteStructureType {
  Note = 'note',
  Document = 'document',
  AutoMode = 'auto_mode',
}

export enum Content {
  Header = 'header',
  InputPlaceholder = 'input_placeholder',
  AskAiTitle = 'ask_ai_title',
  NoteTemplateTitle = 'note_template_title',
  AutoModeTemplateTitle = 'auto_mode_template_title',
}

export enum SortFilter {
  RECENTLY_USED = 'recently used',
  MOST_USED = 'most used',
  ALPHABETICAL = 'alphabetical',
  MOST_RELEVANT = 'most relevant',
  POPULARITY = 'popularity',
}
